import type { FC } from 'react';
import type { SequenceBlockLayout } from './layout-sequence';
import { SequenceText } from './SequenceText';
import { BLOCK_FRAME_DASH, BLOCK_LABEL_HEIGHT, MESSAGE_FONT_SIZE, sequenceColors, } from './sequence-constants';
import { FontWeight } from '@/theme/typography';
const UNLABELED_BLOCK_VALUE = "unlabeledBlock";
const BLOCK_FRAME_RADIUS = 6;
const BLOCK_LABEL_PAD_X = 8;
const BLOCK_LABEL_CHAR_WIDTH = 6;
const BLOCK_LABEL_BASE_WIDTH = 56;
const BLOCK_LABEL_ALIGN = 'start';
const BLOCK_FRAME_FILL = 'none';
const BLOCK_STROKE_WIDTH = 1;
const BLOCK_LABEL_TEXT_SEPARATOR = ' ';
interface SequenceBlockFrameProps {
    block: SequenceBlockLayout;
}
export const SequenceBlockFrame: FC<SequenceBlockFrameProps> = ({ block }) => {
    const blockIdentity = `${block.blockType}-${block.label || UNLABELED_BLOCK_VALUE}`;
    const labelRectWidth = Math.min(block.width, BLOCK_LABEL_BASE_WIDTH + block.label.length * BLOCK_LABEL_CHAR_WIDTH);
    const blockLabel = block.label.length > 0
        ? `${block.blockType}${BLOCK_LABEL_TEXT_SEPARATOR}${block.label}`
        : block.blockType;
    return (
    <g>
      <rect x={block.x} y={block.y} width={block.width} height={block.height} rx={BLOCK_FRAME_RADIUS} ry={BLOCK_FRAME_RADIUS} fill={BLOCK_FRAME_FILL} stroke={sequenceColors.blockStroke} strokeWidth={BLOCK_STROKE_WIDTH} strokeDasharray={BLOCK_FRAME_DASH}/>
      <rect x={block.x} y={block.y} width={labelRectWidth} height={BLOCK_LABEL_HEIGHT} rx={BLOCK_FRAME_RADIUS} ry={BLOCK_FRAME_RADIUS} fill={sequenceColors.blockLabelFill} stroke={sequenceColors.blockStroke} strokeWidth={BLOCK_STROKE_WIDTH}/>
      <SequenceText x={block.x} y={block.y} width={labelRectWidth} height={BLOCK_LABEL_HEIGHT} content={blockLabel} size={MESSAGE_FONT_SIZE} weight={FontWeight.SemiBold} color={sequenceColors.blockLabelText} align={BLOCK_LABEL_ALIGN} padX={BLOCK_LABEL_PAD_X}/>
    </g>
    );
};
